<template>
  <div class="home">
    <div class="home-nav">
      <div class="nav-innerbox">
        <div class="nav-png">
          <span class="text-msg" :class="{ 'zh': $i18n.locale == 'zh' }">{{ $t('m.banner.title') }}</span>
          <div class="input-box">
            <img class="search" src="../assets/images/search_icon.svg" alt="" />
            <input type="text" :placeholder="$t('m.banner.search')" @keyup.enter="goSearch()" v-model="search" />
          </div>
        </div>
      </div>
    </div>
    <div class="home-tab" :class="{ 'zh': $i18n.locale == 'zh' }">
      <div class="tab-innerbox">
        <div class="tab-title-first" :class="{ 'zh': $i18n.locale == 'zh' }">{{
          $t('m.home.tabsTitle')
        }}</div>
        <div class="tab-title">{{ $t('m.home.tabsTitles') }}</div>
        <div class="tab-tabs">
          <div class="tab-clubs" v-for="item, index in this.$store.state.class" :key="index">
            <div class="tab-inner one">
              <router-link :to="'/faq#topic=' + item.id">
                <img :src="item.description" alt="" />
              </router-link>
            </div>
          </div>
          <div class="tab-clubs">
            <div class="tab-inner one">
              <a>
                <img
                  :src="$i18n.locale == 'zh' ? 'https://support-static.partyanimals.cn/wp-content/uploads/2023/08/23154607/supportcard_more_cn%402x.png' : 'https://support-static.partyanimals.com/wp-content/uploads/2023/08/23074841/supportcard_more%402x.png'"
                  alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div> 
    <div class="home-submit" :class="{ 'zh': $i18n.locale == 'zh' }">
      <div class="home-innerbox"  :class="{ 'zh': $i18n.locale == 'zh' }">
        <div class="submit-title" :class="{ 'zh': $i18n.locale == 'zh' }">{{ $t('m.contact.title') }}</div>
        <div class="submit-span" >
          <p>
            {{ $t('m.contact.pone') }}
          </p>
          <p>{{ $t('m.contact.ptwo') }}</p>
        </div>
        <div class="submit-btn" >
          <a @click="goTicket()">
            <div>
              <HoverBtn v-if="$i18n.locale == 'zh'" :width="'228px'" :maxHeight="'74px'" :left="'-114px'"
                :src="require('@/assets/images/contactus_normal_cn.png')"
                :srchover="require('@/assets/images/contactus_hover_cn.png')"
                :srcset="require('@/assets/images/contactus_normal_cn' + '@' + '2x.png')"
                :srcsethover="require('@/assets/images/contactus_hover_cn' + '@' + '2x.png')"></HoverBtn>

              <HoverBtn v-if="$i18n.locale == 'en'" :width="'228px'" :maxHeight="'74px'" :left="'-114px'"
                :src="require('@/assets/images/contactus_normal.png')"
                :srchover="require('@/assets/images/contactus_hover.png')"
                :srcset="require('@/assets/images/contactus_normal' + '@' + '2x.png')"
                :srcsethover="require('@/assets/images/contactus_hover' + '@' + '2x.png')"></HoverBtn>
            </div>
          </a>
        </div>
      </div>
    </div>
    <Featured></Featured>
  </div>
</template>

<script>
import HoverBtn from "../components/HoverBtn.vue";
import Loading from "../components/Loading.vue";
import Featured from "../components/Featured.vue";
export default {
  components: { Featured, HoverBtn, Loading },
  data() {
    return {
      //PROMOTED ARTICLES 选项
      proCheck: "first",
      //INTERESTING ARTICLES 选项
      intCheck: "first",
      search: '',
    };
  },
  methods: {
    goSearch() {
      this.$router.push('/search-results?search=' + this.search)
    },
    //文章推荐按钮功能
    changeArticleLi(btntype) { },
    goTicket() {
      if (this.$store.state.login) {
        this.$router.push("/tickets/new-tickets")
      } else {
        this.$router.push("/login")
      }

    }
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/home.scss";
</style>
